import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';
import { TeaserCardSection } from '../../../app/components/teaser-card/teaser-card.component';
import { imageToPicture } from '../../../app/components/plain-image/plain-image.component';
import { AspectRatio, RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components';

import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { OgImageDirective } from '../../directives/og-image.directive';
import { Section, SectionAttributes } from '../../../app/types/section';
import { CardComponent } from '@knorr-bremse-portals/ngx-components/components/card';
import { StandaloneLinkComponent } from '@knorr-bremse-portals/ngx-components/components/standalone-link';
import { GalleryComponent, provideGalleryIntl } from '@knorr-bremse-portals/ngx-components/components/gallery';
import { PictureComponent } from '@knorr-bremse-portals/ngx-components/components/picture';
import { LocalGalleryIntl } from '../../providers/intl/gallery.intl';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

type TeaserCardSliderSection = Section<
  {
    numColumns: 4 | 6 | 12;
    headline: string;
    cards: TeaserCardSection[];
  } & SectionAttributes,
  [
    'numColumns',
    'headline',
    'cards',
  ],
  'teaser-card-slider'
>;

@Component({
    selector: 'section[app-teaser-card-slider]',
    styleUrls: ['./teaser-card-slider.component.scss'],
    templateUrl: './teaser-card-slider.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        EditorIdDirective,
        OgImageDirective,
        CardComponent,
        StandaloneLinkComponent,
        GalleryComponent,
        PictureComponent,
        RouterOrExternalLinkDirective,
        FsButtonComponent,
    ],
    providers: [
        provideGalleryIntl(LocalGalleryIntl),
    ],
})
export class TeaserCardSliderComponent extends SectionComponent<TeaserCardSliderSection> {

  protected imageToPicture = imageToPicture;
  protected standardAspectRatio = AspectRatio.Standard;

}
